import { persistState } from '../modules/persistence';
import { Dispatch, Middleware, MiddlewareAPI } from 'redux';
import { AppState } from '../redux/reducers';

const nextTick = require('next-tick');

const hydrationMiddleware: Middleware = (store: MiddlewareAPI<AppState>) => {
  return (next: Dispatch<AppState>) => {
    // tslint:disable-next-line no-any
    const a: Dispatch<AppState> = (action: any) => {
      // make sure the action is run through completly before retrieving the store state
      next(action);

      nextTick(() => persistState(store.getState()));
    };
    return a;
  };
};

export default hydrationMiddleware;
